import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as vehicleTypesActions from '../actions/vehicle-types.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwVehicleTypesApiService } from 'app/services/vehicle-types-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class VehicleTypesEffects {
  loadVehicleTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleTypesActions.loadVehicleTypes),
      switchMap(() =>
        this.vehicleTypesApiService.getVehicleTypes().pipe(
          map((response) =>
            vehicleTypesActions.loadVehicleTypesSuccess({ response })
          ),
          catchError((error) =>
            of(vehicleTypesActions.loadVehicleTypesFailed({ error }))
          )
        )
      )
    )
  );

  createVehicleType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleTypesActions.createVehicleType),
      switchMap(({ vehicleType }) =>
        this.vehicleTypesApiService.createVehicleType(vehicleType).pipe(
          switchMap(() => [
            vehicleTypesActions.createVehicleTypeSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_vehicle_type_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleTypesActions.createVehicleTypeFailed({ error }))
          )
        )
      )
    )
  );

  updateVehicleType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleTypesActions.updateVehicleType),
      switchMap(({ vehicleType }) =>
        this.vehicleTypesApiService.updateVehicleType(vehicleType).pipe(
          switchMap((response) => [
            vehicleTypesActions.updateVehicleTypeSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_vehicle_type_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleTypesActions.updateVehicleTypeFailed({ error }))
          )
        )
      )
    )
  );

  deleteVehicleType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleTypesActions.deleteVehicleType),
      switchMap(({ vehicleType }) =>
        this.vehicleTypesApiService.deleteVehicleType(vehicleType).pipe(
          switchMap(() => [
            vehicleTypesActions.deleteVehicleTypeSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_vehicle_type_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleTypesActions.deleteVehicleTypeFailed({ error }))
          )
        )
      )
    )
  );

  deleteVehicleTypesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleTypesActions.deleteVehicleTypesList),
      switchMap(({ vehicleTypes }) =>
        this.vehicleTypesApiService.deleteVehicleTypesList(vehicleTypes).pipe(
          switchMap(() => [
            vehicleTypesActions.deleteVehicleTypesListSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_vehicle_types_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleTypesActions.deleteVehicleTypesListFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private vehicleTypesApiService: MwVehicleTypesApiService
  ) {}
}
